import { metrics } from '@opentelemetry/api';
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

import { isMetricsReady } from './metrics';

export function initializeWebVitals() {
  if (!isMetricsReady()) {
    return;
  }

  const meter = metrics.getMeter('web-vitals');

  const lcp = meter.createHistogram('web.vitals.lcp', {
    description: 'Largest Contentful Paint',
    unit: 'ms',
  });
  const cls = meter.createHistogram('web.vitals.cls', {
    description: 'Cumulative Layout Shift',
  });
  const inp = meter.createHistogram('web.vitals.inp', {
    description: 'Interaction to Next Paint',
    unit: 'ms',
  });
  const ttfb = meter.createHistogram('web.vitals.ttfb', {
    description: 'Time to First Byte',
    unit: 'ms',
  });
  const fcp = meter.createHistogram('web.vitals.fcp', {
    description: 'First Contentful Paint',
    unit: 'ms',
  });

  function sendToAnalytics(metric: Metric) {
    const attributes: Record<string, string | number | boolean> = {
      rating: metric.rating,
    };

    if (metric.name === 'LCP' && metric.entries && metric.entries.length > 0) {
      const entry = metric.entries[metric.entries.length - 1] as
        | (PerformanceEntry & { size?: number; element?: HTMLElement })
        | undefined;
      if (
        entry &&
        'element' in entry &&
        entry.element &&
        entry.element !== null
      ) {
        if (entry.element instanceof HTMLElement) {
          const element = entry.element;
          attributes['lcp.element.tagName'] =
            element.tagName?.toLowerCase() || 'unknown';
          attributes['lcp.element.className'] = element.className || '';
          attributes['lcp.element.id'] = element.id || '';
          attributes['lcp.element.size'] =
            entry.size ||
            Math.round(element.offsetWidth * element.offsetHeight);
        }
      }
    }

    switch (metric.name) {
      case 'LCP':
        lcp.record(metric.value, attributes);
        break;
      case 'CLS':
        cls.record(metric.value, attributes);
        break;
      case 'INP':
        inp.record(metric.value, attributes);
        break;
      case 'TTFB':
        ttfb.record(metric.value, attributes);
        break;
      case 'FCP':
        fcp.record(metric.value, attributes);
        break;
      default:
        console.warn(
          '[OpenTelemetry] Unexpected web vital metric:',
          metric.name,
        );
    }
  }

  onCLS(sendToAnalytics);
  onINP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
  onFCP(sendToAnalytics);
}
